import React, { useEffect, useRef, useState } from 'react';
import { Container, Graphics, Sprite, Text } from '@pixi/react';
import { gsap } from 'gsap';
import { applicationStore } from '../../../../../store/applicationStore';
import CreateTextWinAmountAndCurrencySymbol from '../../../boostedJackpot/createTextWinAmountAndCurrencySymbol';

function BoostedJackpotIconSliderBoard({
  playerBoostedWinAmount,
  setPlayerBoostedWinAmount,
  boostedJackpotIconInfoBoardRectangle,
}) {
  const containerRef = useRef();
  const containerSliderRef = useRef();
  const [mask, setMask] = useState(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.mask = mask;
    }
  }, [mask, containerRef]);
  useEffect(() => {
    if (containerSliderRef.current) {
      gsap.to(containerSliderRef.current, {
        x: -210,
        duration: 1,
        ease: 'none',
        onComplete: () => {
          setTimeout(() => {
            gsap.to(containerSliderRef.current, {
              x: 0,
              duration: 1,
              ease: 'none',
              onComplete: () => {
                setPlayerBoostedWinAmount(null);
              },
            });
          }, 3000);
        },
      });
    }
  }, [setPlayerBoostedWinAmount]);

  return (
    <Container ref={containerRef} name='BoostedJackpotIconSliderBoard'>
      <Container ref={containerSliderRef}>
        <Sprite texture={boostedJackpotIconInfoBoardRectangle} anchor={0.5} />

        <Text
          x={0}
          y={-12}
          anchor={0.5}
          text={applicationStore.canvasTranslationKeys.DAILY_AWARDS_TITLE}
          style={{
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'poppinsMedium',
            fill: '#FFC33E',
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 206,
          }}
          resolution={2}
        />
        <CreateTextWinAmountAndCurrencySymbol
          x={-20}
          y={11}
          color='#FFFFFF'
          amount={playerBoostedWinAmount}
          margin={20}
          fontSize={16}
        />
      </Container>
      <Graphics
        draw={(g) => {
          g.clear();
          g.beginFill('black');
          g.drawRect(
            -320,
            -25,
            boostedJackpotIconInfoBoardRectangle.width + 20,
            boostedJackpotIconInfoBoardRectangle.height + 10
          );
        }}
        ref={(graphicsRef) => setMask(graphicsRef)}
      />
    </Container>
  );
}

export default BoostedJackpotIconSliderBoard;
